module.exports = __webpack_public_path__ + "static/toggl-track-apps copy-c1c98f9ace2b9539378c4894b600b95d.png";